import React from 'react';
import { DConfirmationModal } from '../../../../../dum';
import {
    clearManagement,
    useDeleteTransferMutation,
} from '../../../../../../services';

interface IDeleteTransferProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    transferId: number | null;
}

export function SDeleteTransferDialog({
    open,
    setOpen,
    transferId,
}: IDeleteTransferProps) {
    const [deleteMutation] = useDeleteTransferMutation();

    return (
        <DConfirmationModal
            open={open}
            setOpen={setOpen}
            callback={async () => {
                if (transferId) {
                    try {
                        await deleteMutation({
                            // Deleting the transfer frees every linked
                            // sale/expense back to pending, so refresh the same
                            // management/sales caches the upsert path clears —
                            // otherwise their "pendiente por transferir" stays
                            // stale until a manual reload.
                            update: (cache) => {
                                clearManagement(cache);
                            },
                            variables: {
                                TransferId: transferId,
                            },
                        });
                        setOpen(false);
                    } catch (e) {
                        console.error(e);
                    }
                }
            }}
        />
    );
}
